import React, { Component, useState } from "react";
import Sticky from "Components/Sticky/index";
import Dropdown from "Components/Dropdown/dropdown";
import { ReactComponent as Back } from 'Icons/back.svg'
import Checkbox from "Components/Checkbox/index";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { ReactComponent as Location } from 'Icons/location.svg'
import { ReactComponent as YardIcon } from 'Icons/railFencing.svg'
import { ReactComponent as RefreshIcon } from 'Icons/refresh.svg'
import { AiOutlineCloseCircle, AiOutlinePlusCircle, AiOutlinePlus, } from "react-icons/ai";
import { BsPlusSquareFill } from "react-icons/bs";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import { TiDelete } from "react-icons/ti"
import Input from "Components/FormInput/index";
import { GENERATE_PLAN_IN_MASTER_CONTRACT, GET_CHILD_CONTRACT_TK11, GET_CONTRACT_DETAILS, GET_FROM_ROUTE, GET_GENERATE_ROUTE_CODE, GET_MASTER_CONTRACT_TK11, POST_SEARCH_ROUTES_CONTRACTS, RETRIGGER_MASTER_CONTRACTS_TK11, SAVE_RETRIGGER_MC_TK11 } from "Constants/actionConstants";
import { getUser } from 'Utils/storage';
import { connect } from "react-redux";
import { withRouter } from "react-router";
import moment from 'moment';
import ActionLoader from "Components/ActionLoader/index";
import MultipleDropdown from "Components/MultipleDropdown/index";
import { DateRangePicker } from "react-dates";
import Overlay from "Components/Overlay/index";
import RetriggerPopup from "./retriggerPopup";

const ROW_HEADINGS = {
    transporters: "Transporters",
    surveyors: "Surveyors",
    handling_agents: "Handling Agents",
    lashers: "Lashers",
    securities: "Security"
}

class ContractDetails extends Component {
    constructor(props) {

        super(props);
        this.state = {
            retriggerData: []
        };
    }

    componentDidMount() {
        this.getContractDetails();
    }

    getContractDetails = () => {
        const { dispatch, match } = this.props;
        const user = getUser();
        const data = {
            masterContractId: match && match.params && match.params.contractId
        }
        dispatch({
            type: GET_CONTRACT_DETAILS,
            params: data,
            onSuccess: (data) => {
            }
        })
    }

    getRowHeading = (key) => {
        return ROW_HEADINGS[key]
    }

    toggleRetriggerButton = () => {
        const { dispatch, match } = this.props;
        const data = { 
            masterContractId: match && match.params && match.params.contractId
         }
        dispatch({
            type: GET_MASTER_CONTRACT_TK11,
            params: data,
            onSuccess: (data) => {
                this.setState({
                    retriggerData: data && data.length ? data[0] : null,
                    isRetriggerPopupShown: true
                })
            }
        })
    }

    hideRetriggerPopup = () => {
        this.setState({
            retriggerData: null,
            isRetriggerPopupShown: false
        })
    }

    onRetriggerClick = (contractId) => {
        const { dispatch } = this.props;

        const payload = {
            master_contract_id: contractId
        }

        dispatch({
            type: RETRIGGER_MASTER_CONTRACTS_TK11,
            data: payload,
            onSuccess: () => {
                this.hideRetriggerPopup()
            }
        })
    }

    onRetriggerDataChange = (value, parentKey, key, parentIndex, childIndex) => {
        const { retriggerData } = JSON.parse(JSON.stringify(this.state))

        if ((key == 'Amount' || key == 'finalAmount') && value != 0) {
            const regEx = /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$/;
            const check = value.match(regEx);
            if (!check) {
                return
            }
        }

        let tempRetriggerData = retriggerData

        if(childIndex >= 0){
            if (tempRetriggerData[parentKey] && 
                tempRetriggerData[parentKey].length && 
                tempRetriggerData[parentKey][parentIndex] && 
                tempRetriggerData[parentKey][parentIndex].payload &&
                tempRetriggerData[parentKey][parentIndex].payload.Data && 
                tempRetriggerData[parentKey][parentIndex].payload.Data.length && 
                tempRetriggerData[parentKey][parentIndex].payload.Data[childIndex] )
                {
                    
                    tempRetriggerData[parentKey][parentIndex].payload.Data[childIndex][key] = value
                }
        } else {
            if (tempRetriggerData[parentKey] &&
                tempRetriggerData[parentKey].length &&
                tempRetriggerData[parentKey][parentIndex] && 
                tempRetriggerData[parentKey][parentIndex].payload &&
                tempRetriggerData[parentKey][parentIndex].payload.contractData )
                {
                    tempRetriggerData[parentKey][parentIndex].payload.contractData[key] = value
                }        
        }
        this.setState({
            retriggerData: tempRetriggerData
        })
    }

    onSaveClick = (contractId) => {
        const { retriggerData } = this.state;
        const { dispatch } = this.props;
        
        const data = {
            master_contract_id: contractId,
            child_contracts: retriggerData.child_contracts && retriggerData.child_contracts.length ? retriggerData.child_contracts.map(cData => {
                return {
                    id: cData.id,
                    payload: cData.payload
                }
            }) : [],
            point_contracts: retriggerData.point_contract && retriggerData.point_contract.length ? retriggerData.point_contract.map(pData => {
                return {
                    payload: pData.payload || [],
                    id: pData.id
                }
            }) : [],
            leg_contracts: retriggerData.leg_contracts && retriggerData.leg_contracts.length ? retriggerData.leg_contracts.map(lData => {
                return {
                    payload: lData.payload || [],
                    id: lData.id
                }
            }) : []
        }

        dispatch({
            type: SAVE_RETRIGGER_MC_TK11,
            data: data,
            onSuccess: () => {
                this.hideRetriggerPopup()
            }
        })
    }

    render() {
        const { detailsLoading, data, childDetailsLoading } = this.props

        const { popupType, isRetriggerPopupShown, transporterData } = this.state;

        return (

                <Sticky>
                {(detailsLoading || childDetailsLoading) && <ActionLoader fixed={true} />}

                <div>
                    <div className="flex-middle flex-between" style={{ display: "flex", padding: "20px 20px 10px 20px" }}>
                    <div className="flex flex-middle" style={{ fontWeight: "800", fontSize: "24px", gap: '10px' }}>
                    <div className="fs-18 theme-color curP fBold"
                                onClick={() => {
                                    this.props.history.push('/viewGeneratedContracts')
                                }
                                }>
                                <Back className="fill-theme mr-5" />
                                {'Back'}
                            </div>
                            <span className="ml-10">{data.master_contract_number || '-'}</span>
                        </div>
                        <div className="flex flex-middle fs-16 theme-color fSemibold curP" onClick={this.toggleRetriggerButton} style={{ gap: '10px' }}>TK11 Retrigger <RefreshIcon className="curP" style={{ height: '18px', width: '15px' }} /></div>
                    </div>
                    {/* <hr /> */}
                    <div className="mt-20" style={{ display: "flex", padding: "5px 20px 15px 20px", gap: '20px', boxShadow: '0px 4px 4px rgba(98, 127, 233, 0.45)' }}>
                        <div className="border-right-dark pr-10">
                            <span className="fBold">Contract Tenure: </span><br />
                            {data.contract_tenure_from ? moment(data.contract_tenure_from).format('DD/MM/YYYY') : '-'} To {data.contract_tenure_to ? moment(data.contract_tenure_to).format('DD/MM/YYYY') : '-'}
                        </div>
                        <div className="border-right-dark pr-10">
                            <span className="fBold">Route Code: </span><br />
                            {data.route_code || '-'}
                        </div>
                        <div>
                            <span className="fBold" style={{ color: '#364680' }}>From </span><br />
                            <div className="flex mt-5" style={{ gap: '10px' }}><Location style={{ height: '18px', width: '15px' }} /><span className="fSemibold">{data.from || '-'}</span></div>
                        </div>
                        <div>
                            <span className="fBold" style={{ color: '#8D1722' }}>Origin Yard </span><br />
                            <div className="flex mt-5" style={{ gap: '10px' }}><YardIcon style={{ height: '18px', width: '15px' }} /><span className="fSemibold">{data.origin_yard || '-'}</span></div>
                        </div>
                        <div>
                            <span className="fBold" style={{ color: '#8D1722' }}>Destination Yard </span><br />
                            <div className="flex mt-5" style={{ gap: '10px' }}><YardIcon style={{ height: '18px', width: '15px' }} /><span className="fSemibold">{data.destination_yard || '-'}</span></div>
                            <div className="flex mt-5" style={{ gap: '10px' }}><Location style={{ height: '18px', width: '15px' }} /><span className="fSemibold">{data.to || '-'}</span></div>
                        </div>
                    </div>

                    <div style={{ padding: '0px 20px 20px' }}>
                        {
                            data && data.required_data && Object.keys(data.required_data).map((ele, idx) => {
                                return (
                                    <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px", borderCollapse: 'collapse' }}>
                                        <thead className="ht-40 fs-14 fBold mr-5 mt-10 curP table-bg-blue white-color">
                                            <tr className="br-10">
                                                <th className='' colSpan={4}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        <div style={{ paddingLeft: "5px" }}>
                                                            <Location className="fill-white" style={{ height: '18px', width: '15px' }} />
                                                        </div>
                                                        <span>{ele}</span>
                                                        <span style={{ marginLeft: 'auto', paddingRight: '10px' }}></span>
                                                    </div></th>

                                                {/* <th className='col-4 tLeft' onCheck={() => { this.selectAllScheduleRecords() }}>L1</th>
                      <th className='col-4 tLeft' onCheck={() => { this.selectAllScheduleRecords2() }}>L2</th>
                      <th className='col-4 tLeft' onCheck={() => { this.selectAllScheduleRecords3() }}>L3</th> */}
                                            </tr>
                                        </thead>


                                        <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
                                            {/* FIRST TABLE */}

                                            {
                                                Object.keys(data.required_data[ele]).map((subEle, sIndex) => {

                                                    const dataList = data.required_data[ele][subEle]

                                                    if (dataList && dataList.length) {
                                                        return (
                                                            <tr key={sIndex} style={{ borderBottom: '1px solid black' }} >
                                                                <td style={{ width: '170px' }} className="tLeft p-5 pl-10  master-contract-font-color last-child">
                                                                    {this.getRowHeading(subEle) || '-'}
                                                                </td>

                                                                {
                                                                    ['L1', 'L2', 'L3'].map((type) => {
                                                                        return (
                                                                            <td style={{ padding: "20px 0px" }}>
                                                                                {dataList.map((info, dIndex) => {
                                                                                    return (
                                                                                        <>
                                                                                            {(type == info.order_text) && <div style={{ paddingBottom: `${(data.length > (dIndex + 1)) ? '20px' : '0px'}` }}>
                                                                                                <div style={{ paddingTop: "10px", display: "flex", gap: "10px", alignItems: "center" }}>
                                                                                                    <th className='tLeft' key={idx}>{info.transporter_name}</th>
                                                                                                    <span style={{ background: type == 'L1' ? "green" : '#fd9901', color: "white", padding: "5px", borderRadius: "99px" }}>{info.order_text}</span>
                                                                                                </div>
                                                                                                <span>
                                                                                                    <strong>Rate:</strong>  {info.price} Per MT
                                                                                                </span>
                                                                                            </div>}
                                                                                        </>
                                                                                    )
                                                                                })
                                                                                }
                                                                            </td>
                                                                        )
                                                                    })
                                                                }

                                                            </tr>
                                                        )

                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                )
                            })
                        }
                    </div>
                </div>
                {isRetriggerPopupShown && <RetriggerPopup onSaveClick={this.onSaveClick} close={this.hideRetriggerPopup} onRetriggerDataChange={this.onRetriggerDataChange} onRetriggerClick={this.onRetriggerClick} data={this.state.retriggerData}/>}
            </Sticky>
        )
    }
}

const mapStateToProps = ({ contracting }) => {
    return {
        fromRoutes: contracting.fromRoutes || [],
        detailsLoading: contracting.masterContractDetails.dataLoading,
        childDetailsLoading: contracting.masterContractDetails.childDetailsLoading,
        data: contracting.masterContractDetails.data || {}
    }
};

export default connect(mapStateToProps, null)(withRouter(ContractDetails));